export default {
  // aboutInfo (state) {
  //   return state.pageAbout
  // }
};
